<template>
  <v-form class="registration-form">
    <v-text-field
      v-model="first_name"
      :error-messages="error['first_name']"
      label="First name"
      color="teal lighten-2"
      required
      outline
      clearable
      dark
      prepend-inner-icon="fas fa-user fa-sm"
      class="round theme"
    />
    <v-text-field
      v-model="last_name"
      :error-messages="error['last_name']"
      label="Last name"
      color="teal lighten-2"
      required
      clearable
      outline
      dark
      prepend-inner-icon="fas fa-user fa-sm"
      class="round theme"
    />
    <v-text-field
      v-model="email"
      :error-messages="error['email']"
      label="Email"
      color="teal lighten-2"
      required
      clearable
      outline
      dark
      prepend-inner-icon="far fa-envelope fa-sm"
      class="round theme"
    />
    <v-autocomplete
      v-model="business"
      :error-messages="error['business']"
      :items="initial.business"
      label="Business"
      color="teal lighten-2"
      item-text="name"
      required
      clearable
      outline
      dark
      prepend-inner-icon="fas fa-dollar-sign fa-sm"
      class="round theme"
      return-object
    />
    <v-autocomplete
      v-model="office"
      :error-messages="error['office']"
      label="Office"
      color="teal lighten-2"
      :items="business['office']"
      item-text="name"
      required
      clearable
      outline
      dark
      prepend-inner-icon="fas fa-store-alt fa-sm"
      class="round theme"
    />
    <v-combobox
      v-model="team"
      :error-messages="error['team']"
      :items="initial.teams"
      label="Team"
      color="teal lighten-2"
      open-on-clear
      required
      clearable
      outline
      dark
      prepend-inner-icon="fas fa-shield-alt fa-sm"
      class="round theme"
    ></v-combobox>
    <v-text-field
      v-model="password"
      :error-messages="error['password']"
      label="Password"
      type="password"
      color="teal lighten-2"
      required
      clearable
      outline
      dark
      prepend-inner-icon="fas fa-lock fa-sm"
      autocomplete="new-password"
      class="round theme"
    />

    <v-dialog
      v-model="registrationDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      class="registration-dialog"
    >
      <div
        class="registration-dialog__inner"
      >
        <div>
          <i class="registration-dialog__icon far fa-check-circle fa-8x"></i>
          <h1 class="registration-dialog__title">Your account <br> has been created</h1>
        </div>
      </div>

    </v-dialog>

    {{ error['detail'] }}
    <br>
    <div class="registration-dialog__help">
      <p>Your password must contain at least 8 characters.</p>
    </div>
    <div @click="register">
      <BottomPanel button-text="Create My Account" />
    </div>
  </v-form>
</template>

<script>
  import BottomPanel from "./BottomPanel";
  import { mapGetters } from "vuex";


  export default {
    name: "RegistrationForm",
    components: {
      BottomPanel
    },
    data() {
      return {
        registrationDialog: false,
        form_title: "",
        first_name: "",
        last_name: "",
        business: "",
        email: "",
        password: "",
        team: "",
        office: "",
      }
    },
    computed: {
      ...mapGetters(
        'authentication', ['status', 'error', 'initial'],
        ),
    },
    mounted() {
      this.$store.dispatch('authentication/register_initial');
      this.$nextTick(function () {
        this.$store.dispatch('authentication/clearErrors');
      });
    },
    methods: {
      register: function () {
        const {
          first_name,
          last_name,
          email,
          password,
          team,
          office
        } = this;

        this.$store
          .dispatch('authentication/register', {
            first_name,
            last_name,
            team,
            office,
            email,
            password
          })
         .then(() => {
           this.registrationDialog = true;
           setTimeout(() => {
             this.$router.push("/login");
           }, 3000)
         })
         .catch(() => {
         });
      }
    }
  };
</script>

<style scoped>
  .registration-form {
    padding-bottom: 150px;
  }

  .registration-dialog {

  }

  .registration-dialog__inner {
    height: 100vh;
    background-color: #212121;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }

  .registration-dialog__icon {
    position: relative;
    padding-bottom: 15px;
    margin-bottom: 15px;
    color: #4DB6AC;
  }

  .registration-dialog__title {
    font-size: 30px;
    line-height: 35px;
  }
  .registration-dialog__help p {
    margin-bottom: 2px;
    }
</style>

